"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_1 = require("../../../utils/analytics");
function setupAnalytics(storeData) {
    (function setupFPTI(win, doc) {
        var DEPTH_LIMIT = 5;
        if (!win.fpti) {
            win.fpti = {};
        }
        function getPageName(url) {
            if (url === void 0) { url = win.location.pathname; }
            return analytics_1.default.getPageNameFromUrl(url);
        }
        win.fpti = storeData && storeData.sys.tracking.fpti;
        var fptiName = getPageName() || win.fpti.name, fptiDataString = win.fpti['dataString'], // eslint-disable-line
        fptiServerURL = win.fpti['serverURL']; // eslint-disable-line
        win.PAYPAL = win.PAYPAL || {};
        if (typeof win.PAYPAL.analytics !== 'undefined') {
            win.PAYPAL.core = win.PAYPAL.core || {};
            win.PAYPAL.core[fptiName] = win.PAYPAL.analytics.setup({
                data: fptiDataString,
                url: fptiServerURL
            });
        }
        function setFPTIInstance() {
            win.PAYPAL.instance = new PAYPAL.analytics.Analytics();
            win.PAYPAL.instance.options.request.url = fptiServerURL;
        }
        // Alternative to pointer-events in CSS.
        // Drills up to 5 levels to check for 'A' or 'BUTTON' tags
        function getLinkName(elementNode, currentDepthCount) {
            if (currentDepthCount === void 0) { currentDepthCount = 0; }
            if (currentDepthCount > DEPTH_LIMIT || !elementNode) {
                return '';
            }
            if (elementNode.tagName.toUpperCase() === 'A' || elementNode.tagName.toUpperCase() === 'BUTTON') {
                return elementNode.dataset.fpti || '';
            }
            currentDepthCount = currentDepthCount + 1;
            return getLinkName(elementNode.parentElement, currentDepthCount);
        }
        function triggerFPTIClick(linkName) {
            if (!win.PAYPAL.instance) {
                setFPTIInstance();
            }
            win.fpti.link = linkName;
            win.fpti.pglk = win.fpti.pgrp + '|' + linkName;
            win.fpti.pgln = win.fpti.page + '|' + linkName;
            if (win.PAYPAL.instance) {
                win.PAYPAL.instance.recordClick();
            }
        }
        function triggerFPTIImpression() {
            var pageGroup = 'main:' + win.fpti.comp + ':' + getPageName(), pageName = 'main:' + win.fpti.comp + ':' + getPageName() + ':::', locale = '';
            if (storeData && storeData.locality.country) {
                locale = storeData.locality.country;
            }
            if (win.fpti.link) {
                win.fpti.rlink = win.fpti.link;
            }
            if (win.fpti.pglk) {
                win.fpti.rpage = win.fpti.page;
            }
            win.fpti.pgrp = pageGroup;
            win.fpti.page = pageName;
            win.fpti.link = null;
            win.fpti.pglk = null;
            win.fpti.pgln = null;
            win.fpti.ccpg = locale;
            if (win.PAYPAL.instance) {
                win.PAYPAL.instance.recordImpression();
            }
        }
        function clickListener(e) {
            // TODO: Remove defaults after names are integrated across the app
            var listOfSupportedTags = {
                'A': true,
                'BUTTON': true,
                // For radio buttons
                'LABEL': function (event) {
                    return event.target.getAttribute('for');
                }
            }, isSupportedForTracking = listOfSupportedTags[e.target.tagName.toUpperCase()], linkName = e.target.dataset.fpti || e.target.getAttribute('for') || '';
            if (isSupportedForTracking && (isSupportedForTracking === true || isSupportedForTracking(e))) {
                triggerFPTIClick(linkName);
            }
            else if (e.target.tagName.toUpperCase() === 'DIV' || e.target.tagName.toUpperCase() === 'SPAN') {
                triggerFPTIClick(getLinkName(e.target));
            }
        }
        win.addEventListener('click', clickListener, false);
        win.PAYPAL.fpti = {
            triggerFPTIClick: triggerFPTIClick,
            triggerFPTIImpression: triggerFPTIImpression
        };
        return win.PAYPAL.fpti;
    }(window, document));
}
exports.default = setupAnalytics;
